import { render, staticRenderFns } from "./DiscountRuleCheck.vue?vue&type=template&id=381d6e8a&scoped=true&"
import script from "./DiscountRuleCheck.vue?vue&type=script&lang=js&"
export * from "./DiscountRuleCheck.vue?vue&type=script&lang=js&"
import style0 from "./DiscountRuleCheck.vue?vue&type=style&index=0&id=381d6e8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381d6e8a",
  null
  
)

export default component.exports